<main role="main" id="content" class="pale-grey-bg">
  <section class="intro">
    <div class="intro-video-bg">
      <iframe src="https://player.vimeo.com/video/815118655?h=20511d358e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen  title="An introduction To AmiLearn"></iframe>
      <script src="https://player.vimeo.com/api/player.js"></script>
    </div>

    <div class="intro-form-bg">
      <app-join-form />
    </div>
  </section>

  <!-- three boxes that are not cards, no bg, just text and titles/icons/images -->
  <section class="how-why-what">
    <div class="three-col-grid" role="navigation">    
      <a [routerLink]="currentRoute" queryParamsHandling="preserve" fragment="how-it-works" role="link">
        <div class="btn-icon icon__ami-blue">
          <picture>
            <source type="image/webp" srcset="/assets/imgs/icons/AmiLearn-icon_Reverse__Cog.webp">
            <source type="image/png" srcset="/assets/imgs/icons/AmiLearn-icon_Reverse__Cog.png">
            <img type="image/png" src="/assets/imgs/icons/AmiLearn-icon_Reverse__Cog.png" width="44" alt="a small single cog indicating the details of how it works" title="Look into how it works">
          </picture>
        </div>
        <span class="sr-text">Scroll to the How it Works section</span>
        <h2>How it works</h2>
      </a>
          
      <a [routerLink]="currentRoute" queryParamsHandling="preserve" fragment="what-you-get"  role="link">
        <div class="btn-icon icon__ami-blue">
          <picture>
            <source type="image/webp" srcset="/assets/imgs/icons/AmiLearn-icon_Reverse__Concept.webp">
            <source type="image/png" srcset="/assets/imgs/icons/AmiLearn-icon_Reverse__Concept.png">
            <img type="image/png" src="/assets/imgs/icons/AmiLearn-icon_Reverse__Concept.png" width="44" alt="A defender sheild with a checkmark at its center becons you to discover what you get" title="Discover what you get">
          </picture>
        </div>
        <span class="sr-text">Scroll to the What you Get section</span>
        <h2>What you get</h2>
      </a>
    
      <a [routerLink]="currentRoute" queryParamsHandling="preserve" fragment="why-it-matters" role="link">
        <div class="btn-icon icon__ami-blue">
          <picture>
            <source type="image/webp" srcset="/assets/imgs/icons/AmiLearn-icon_Reverse__Shield.webp">
            <source type="image/png" srcset="/assets/imgs/icons/AmiLearn-icon_Reverse__Shield.png">
            <img type="image/png" src="/assets/imgs/icons/AmiLearn-icon_Reverse__Shield.png" width="44" alt="a hand cups a lightbulb lightly, inviting you to find out why learning matters" title="Find out why it matters">
          </picture>
        </div>
        <span class="sr-text">Scroll to the Why it Matters section</span>
        <h2>Why it matters</h2>
      </a>      
    </div><!-- ends row of three cards -->
  </section>

  <section class="how-it-works" id="how-it-works">
    <article>
      <div class="simple-banner">
        <h2>
          <span class="sub-titling">How it works:</span><br>
          <span>Your Learning Partner For&nbsp;Digital&nbsp;Asset Investing.</span>
        </h2>
      </div>

      <div class="how-it-works--content">
        <p>AmiLearn is a subscription-based learning and collaboration platform offering a continuous learning journey for Wealth and Asset Managers, Advisors, and financial services professionals.</p>
        <p>This comprehensive learning approach empowers the Advisor to take control of the Digital Asset conversation.</p>
        <p class="button-box--paragraph">
          <button
            class="btn btn-secondary"
            type="button"
            [routerLink]="currentRoute"
            queryParamsHandling="preserve"
            fragment="top"
            (click)="scrollTop()"
          >
            Join now
          </button>
        </p>
      </div>
    </article>
  </section>

  <section class="what-you-get" id="what-you-get">
    <article>
      <div class="simple-banner">
        <h2><span class="sub-titling">What you get:</span><br>
          <span>A Competitive Advantage That Comes With Knowledge.</span>
        </h2>
      </div>

      <div class="card-container pull-it-up">
        <div class="three-cards">
          <div *ngFor="let card of cards" class="ami-card large-card">
            <app-information-card
              style="display: contents"
              [title]="card.title"
              [description]="card.description"
              [a11yImages]="card.a11yImages"
            >
              <img
                [src]="card.image.url"
                [attr.alt]="card.image.alt || null"
                [width]="card.image.width || null"
                [title]="card.image.title || null"
              >
            </app-information-card>
          </div>
        </div><!-- ends row of three cards -->
      </div>
    </article>
  </section>

  <section class="why-it-matters" id="why-it-matters">
    <article>
      <div class="simple-banner">
        <h2>
          <span class="sub-titling">Why it Matters:</span><br>
          <span>Investors Want Guidance From Their Advisors. Now!</span>
        </h2>
      </div>
      <div class="why-it-matters--content">
        <p>Interest in Digital Assets is growing at an unprecedented rate. The reality that Advisors face today is that their clients are investing in Digital Assets without professional advice, putting themselves at high risk.
        </p>
        <p>AmiLearn provides the tools and resources so Advisors can lead the Digital Asset conversation with their clients.</p>

        <div class="quote-split">
          <div class="quote-split--left">
            <h3>1 Trillion+</h3>
            <p>"Nontraditional Wealth Managers currently manage up to $1 trillion in crypto-related wealth, and the market capitalization for crypto could increase four-to-fivefold by 2030."</p>
            <p>- Boston Consulting Group</p>
          </div>
          <div class="divider"></div>
          <div class="quote-split--right">
            <h3>94%</h3>
            <p>"Ninety four percent of Advisors received a question about crypto from clients last year. The most common question was: "Should I consider an investment in crypto?"</p>
            <p>- Bitwise</p>
          </div>
        </div>

          <div class="button-box--grid">
            <button
              class="btn btn-secondary"
              type="button"
              [routerLink]="currentRoute"
              queryParamsHandling="preserve"
              fragment="top"
              (click)="scrollTop()"
            >
              Join now
            </button>
          </div>
        </div>
    </article>
  </section>
  <app-learn-more />
</main>